<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-walking`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M17.98 3.006l-.155-.112a3 3 0 00-3.962.524L3.124 15.903l-.122.152a3 3 0 00.4 4.043L31.332 45H43l.176-.005A3 3 0 0046 42v-7.037l-.005-.2a4 4 0 00-3.995-3.8h-4.076L34.12 11.427l-.04-.174A3 3 0 0031.176 9h-5.49L17.98 3.006zM6.796 17.766l9.478-11.018L24.314 13h6.038l.779 4H25a1 1 0 00-1 1v2a1 1 0 001 1h6.909l.779 4H29a1 1 0 00-1 1v2a1 1 0 001 1h4.466l1.161 5.963H42V41h-9.143L6.797 17.766z"/></svg>
</template>
<script>

export default {
  name: 'IconWalking',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
